"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.initializeLocal = initializeLocal;
exports.eventLogger = eventLogger;
exports.setUser = setUser;
exports.setUserProperties = setUserProperties;
exports.default = void 0;

var _amplitudeJs = _interopRequireDefault(require("amplitude-js"));

var _eventCategories = require("./constants/eventCategories");

var DEFAULT_AMPLITUDE_CONFIGS = {
  includeUtm: true,
  includeReferrer: true
};

function initialize(key, options) {
  var settings = Object.assign({}, DEFAULT_AMPLITUDE_CONFIGS, options);
  window.amplitude = window.amplitude || _amplitudeJs.default;
  window.amplitude.getInstance().init(key, null, settings);
}

function initializeLocal() {
  window.amplitude = window.amplitude || {
    _instances: {},
    getInstance: function getInstance() {
      return {
        logEvent: function logEvent() {
          var _console;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          (_console = console).log.apply(_console, ["[Amplitude]"].concat(args)); // eslint-disable-line no-console

        }
      };
    }
  };
}

function eventLogger(eventName, params) {
  if (!window.amplitude) {
    throw new Error("Amplitude not initialized");
  }

  window.amplitude.getInstance().logEvent(eventName, params);
}

function setUser(userId, props) {
  _amplitudeJs.default.getInstance().setUserId(userId);

  if (props) {
    setUserProperties(props);
  }
}

function setUserProperties(props) {
  _amplitudeJs.default.setUserProperties(props);

  analytics.eventLogger("setUserProperties", {
    category: _eventCategories.eventCategories.SESSION
  });
} // help mocking eventLogger in setUser for unit test


var analytics = {
  eventLogger: eventLogger,
  initialize: initialize,
  setUser: setUser,
  setUserProperties: setUserProperties
};
var _default = analytics;
exports.default = _default;